import React from 'react'

// Root svg holding the gradients for sankey paths
export const ColorGradientRoot = () => (
  <svg height="0">
    <linearGradient id="sankey-color-gradient-purpleBlue">
      <stop offset="5%" stopColor="var(--drift-dds-colors-purple8)" />
      <stop offset="95%" stopColor="var(--drift-dds-colors-blue8)" />
    </linearGradient>
    <linearGradient id="sankey-color-gradient-blueTeal">
      <stop offset="5%" stopColor="var(--drift-dds-colors-blue8)" />
      <stop offset="95%" stopColor="var(--drift-dds-colors-teal5)" />
    </linearGradient>
    <linearGradient id="sankey-color-gradient-tealGreen">
      <stop offset="5%" stopColor="var(--drift-dds-colors-teal5)" />
      <stop offset="95%" stopColor="var(--drift-dds-colors-green6)" />
    </linearGradient>
    <linearGradient id="sankey-color-gradient-tealGreen">
      <stop offset="5%" stopColor="var(--drift-dds-colors-teal5)" />
      <stop offset="95%" stopColor="var(--drift-dds-colors-green6)" />
    </linearGradient>
    <linearGradient id="sankey-color-gradient-blueOrange">
      <stop offset="5%" stopColor="var(--drift-dds-colors-blue8)" />
      <stop offset="95%" stopColor="var(--drift-dds-colors-orange6)" />
    </linearGradient>
    <linearGradient id="sankey-color-gradient-tealYellow">
      <stop offset="5%" stopColor="var(--drift-dds-colors-teal5)" />
      <stop offset="95%" stopColor="var(--drift-dds-colors-yellow6)" />
    </linearGradient>
    <linearGradient id="sankey-color-gradient-yellowGreen">
      <stop offset="5%" stopColor="var(--drift-dds-colors-yellow6)" />
      <stop offset="95%" stopColor="var(--drift-dds-colors-green6)" />
    </linearGradient>
    <linearGradient id="sankey-color-gradient-orangeBlue">
      <stop offset="5%" stopColor="var(--drift-dds-colors-orange6)" />
      <stop offset="95%" stopColor="var(--drift-dds-colors-blue8)" />
    </linearGradient>
    <linearGradient id="sankey-color-gradient-yellowBlue">
      <stop offset="5%" stopColor="var(--drift-dds-colors-yellow6)" />
      <stop offset="95%" stopColor="var(--drift-dds-colors-blue8)" />
    </linearGradient>
    <linearGradient id="sankey-color-gradient-yellowRed">
      <stop offset="5%" stopColor="var(--drift-dds-colors-yellow6)" />
      <stop offset="95%" stopColor="var(--drift-dds-colors-red8)" />
    </linearGradient>
    <linearGradient id="sankey-color-gradient-orangeRed">
      <stop offset="5%" stopColor="var(--drift-dds-colors-orange6)" />
      <stop offset="95%" stopColor="var(--drift-dds-colors-red8)" />
    </linearGradient>
    <linearGradient id="sankey-color-gradient-orangeYellow">
      <stop offset="5%" stopColor="var(--drift-dds-colors-orange6)" />
      <stop offset="95%" stopColor="var(--drift-dds-colors-yellow6)" />
    </linearGradient>
    <linearGradient id="sankey-color-gradient-redBlue">
      <stop offset="5%" stopColor="var(--drift-dds-colors-red8)" />
      <stop offset="95%" stopColor="var(--drift-dds-colors-blue8)" />
    </linearGradient>
    <linearGradient id="sankey-color-gradient-blueGreen">
      <stop offset="5%" stopColor="var(--drift-dds-colors-blue8)" />
      <stop offset="95%" stopColor="var(--drift-dds-colors-green6)" />
    </linearGradient>
    <linearGradient id="sankey-color-gradient-tealBlue">
      <stop offset="5%" stopColor="var(--drift-dds-colors-teal5)" />
      <stop offset="95%" stopColor="var(--drift-dds-colors-blue8)" />
    </linearGradient>
    <linearGradient id="sankey-color-gradient-tealRed">
      <stop offset="5%" stopColor="var(--drift-dds-colors-teal5)" />
      <stop offset="95%" stopColor="var(--drift-dds-colors-red8)" />
    </linearGradient>
  </svg>
)
